import React, { useEffect, useState } from "react";
import httpRequest from "../../../../utils/Http";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import MainBody from "../../../../component/MainBody";
import { Link } from "react-router-dom";
import { openSignUrl } from "../../../../utils/HelperFunction";
import { toast } from "react-toastify";
import MyDataTable from "../../../../component/MyDataTable";
import { useSelector } from "react-redux";


const UploadApplianceMapping = () => {
  const user = useSelector((state) => state.authReducer.currentUser); 
  const [partnerlist, setPartnerlist] = useState([]);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);
  const [reloadList, setReload] = useState(true);

  useEffect(() => {

    if(user){
      // Set initial form data based on user entity type
      if (Number(user.entity_type) === 2) {
        setFormData({
          partner_id: user.entity_id,
        });
      }
    }

  }, [user])

  useEffect(() => {
    (async () => {
      const partners = await httpRequest(
        "getpartnerlist?is_active=1",
        {},
        "GET"
      );
     // console.log(partners);
      if (partners.status === true && partners.data) {
        setPartnerlist(partners.data["rows"]);
      }
    })();
  }, []);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    //console.log(formData);
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const validateFrom = (value) => {
    const errors = {};
    //console.log(value);
    if (!value.partner_id) {
      errors.partner_id = "Partner Name is Required";
    }

    if (!value.file) {
      errors.file = "File is Required (Only xlsx & xls file)";
    }

    return errors;
  };

  const columns = [
    {
      name: "SNo.",
      selector: (_, index) => index + 1,
    },
    {
      name: "File Name",
      selector: (row) => row.file_name,
      cell: (row) => (
        <Link
          to={"#"}
          className="btn-link text-primary"
          onClick={() => openSignUrl(row.file_path)}
        >
          {row.file_name}
        </Link>
      ),
    },
    {
      name: "Agent Name",
      selector: (row) => row.agent_detail.name,
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      name: "Create Date",
      selector: (row) => new Date(row.createdAt).toDateString(),
    },
  ];

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        document.getElementById("bulkupload").reset();
        const data = await httpRequest(
          "uploadappliancemappingfile",
          formData,
          "POST",
          "multipart/form-data"
        );

        if (data.status === true && data.message) {
          toast.success(data.message);
          setReload(true);
        } else {
          toast.error(data.message);
        }
        setSubmit(false);
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  return (
    <MainBody
      breadcrumbTitle="Dashboard"
      breadcrumbSubTitle=""
      navButton=""
      title=""
      component={
        <>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card p-3">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h3 className="card-title m-0">Upload Appliance Mapping File</h3>
                      <Link
                        to={"#"}
                        className="btn btn-link text-primary ml-auto"
                        onClick={() =>
                          openSignUrl("samplefolder/bulkappliancemappingupload.xlsx")
                        }
                      >
                        Download Sample File
                      </Link>
                    </div>

                    <div className="card-body">
                      <form
                        id="bulkupload"
                        onSubmit={onSubmitHandler}
                        encType="multipart/form-data"
                      >
                        <div className="row">

                        {Number(user.entity_type) === 1 && (
                          
                          <div className="col-md-4">
                          {/* Partner Selection */}
                            <div className="form-group">
                              <label>
                                Partner *{" "}
                                <span className="text-danger">
                                  {formErrors.partner_id}
                                </span>
                              </label>
                              <Select
                                options={partnerlist}
                                onChange={(val) =>
                                  setFormData({
                                    ...formData,
                                    partner_id: val.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        )}
                         
                          

                          {/* File Upload */}
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>
                                Excel *{" "}
                                <span className="text-danger">
                                  {formErrors.file}
                                </span>
                              </label>
                              <input
                                type="file"
                                className="form-control"
                                accept=".xlsx, .xls"
                                onChange={(e) => {
                                  var files = e.target.files;
                                  if (files && files[0]) {
                                    var file_name = files[0].name;
                                    const regex = new RegExp(
                                      "(.*?)(xlsx|xls)$"
                                    );
                                    if (!regex.test(file_name.toLowerCase())) {
                                      setFormErrors({
                                        file: "Only .xlsx & .xls files allowed",
                                      });
                                    } else {
                                      setFormData({
                                        ...formData,
                                        file: files[0],
                                      });
                                    }
                                  }
                                }}
                              />
                            </div>
                          </div>

                          <div
                            className="col-md-4 d-flex align-items-center"
                            style={{ marginTop: "14px" }}
                          >
                            <div className="col-md-6">
                              <button
                                type="submit"
                                id="submit"
                                className="btn btn-dark"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">File Upload History</h3>
                    </div>
                    <div className="tab-content">
                      <div className="tab-pane tabc active" id="filehistory">
                        <MyDataTable
                          reloadList={reloadList}
                          columns={columns}
                          getDataListURL={`getfileuploadhistory?type=BULK_APPLIANCE_MAPPING_EXCEL`}
                          setReload={setReload}
                          exportName={"fileuploadlist"}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6"></div>
              </div>
            </div>
          </section>
        </>
      }
    />
  );
};

export default UploadApplianceMapping;
